import script from "./DeptPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptPicker.vue?vue&type=script&setup=true&lang=js"

import "./DeptPicker.vue?vue&type=style&index=0&id=0eb27686&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb27686"]])

export default __exports__